import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { BodyText, ButtonGroup, theme, useResponsive } from '@sg/garnish';
import { type DeliveryPreferenceType } from '@sg/graphql-schema';

import { useDeliveryPreferences } from '../../hooks';

export const AddressFormDeliveryPreference = (
  props: AddressFormDeliveryPreferenceProps,
) => {
  const { value, onChange } = props;

  const { currentBreakpoint, match } = useResponsive();
  const itemsHorizontalPadding = match(['3', '4'] as const);

  const deliveryPreferences = useDeliveryPreferences();

  return (
    <View style={currentBreakpoint.isXS ? styles.mobileSections : undefined}>
      <BodyText style={styles.text}>
        <FormattedMessage {...messages.dropOffLabel} />
      </BodyText>

      <ButtonGroup
        fluid
        value={value}
        items={deliveryPreferences}
        itemsHorizontalPadding={itemsHorizontalPadding}
        // @ts-expect-error (ts 2322)
        onChange={onChange}
      />
    </View>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  dropOffLabel: {
    defaultMessage: 'Drop-Off',
    description: 'Address Form | Delivery Preference | Drop-off label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type AddressFormDeliveryPreferenceProps = Readonly<{
  value: DeliveryPreferenceType;
  onChange: (value: DeliveryPreferenceType) => void;
}>;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    fontSize: 12,
    lineHeight: theme.spacing['4'],
    paddingBottom: theme.spacing['2'],
  },
  mobileSections: { paddingTop: theme.spacing['4'] },
});
